import { keyName } from '@bingads-webui/keycode';

import _ from 'underscore';
import $ from 'jquery';
import { StepsWizard } from '../view/index';
import headerWithPencilTemplate from '../template/header-with-pencil.pug';

/** Class representing a StepsWizard builder */
export class StepsWizardBuilder {
  /**
   * Create a steps wizard builder
   */
  constructor() {
    this.config = {
      steps: [],
    };
  }

  /**
   * Add one step for the steps wizard builder
   *
   * @param {String} name the name of the step
   * @param {Object} view the Backbone view instance of the step
   * @returns {Object} the builder instance
   */
  withStep(name, view) {
    this.config.steps.push({ name, view });

    return this;
  }

  /**
   * Set the starting point for the steps flow
   *
   * @param {String} stepName the name of the step which you want to start with
   * @returns {Object} the builder instance
   */
  startsFrom(stepName) {
    this.currentStep = stepName;

    return this;
  }

  /**
   * Set customized events.
   *
   * @param {Hash} events k-v pairs for the events .
   * @returns {Object} the builder intance
   */
  setEvents(events) {
    if (_.isEmpty(this.config.events)) {
      this.config.events = events;

      return this;
    }

    throw new Error('Cannot set events multiple times');
  }

  /**
   * Call this method to apply horizontal layout.
   *
   * @returns {Object} the builder intance
   */
  withHorizontalLayout() {
    this.config.isHorizontal = true;

    return this;
  }

  /**
   * Set the custom layout
   *
   * @param {Function} layout template function of the layout .
   * @returns {Object} the builder intance
   */
  withLayout(layout) {
    this.config.layout = layout;

    return this;
  }

  /**
   * Set the custom events.
   *
   * @param {Function} actionTemplate template function of the action item
   * @returns {Object} the builder intance
   */
  withActionTemplate(actionTemplate) {
    this.config.actionTemplate = actionTemplate;

    return this;
  }

  setInitialState(state) {
    this.initialState = state;

    return this;
  }

  withEditButton() {
    function editStep(e) {
      if (!e.key || e.key === keyName[13]) {
        const targetStepName = $(e.target).closest('.step-header')[0].dataset.stepName;

        this.stepsWizardInstance.goTo(targetStepName);
      }
    }

    this.config.headerTemplate = headerWithPencilTemplate;

    if (_.isEmpty(this.config.events)) {
      this.config.events = {
        'click .edit-step': editStep.bind(this),
        'keypress .edit-step': editStep.bind(this),
      };
    } else {
      this.config.events['click .edit-step'] = editStep.bind(this);
      this.config.events['keypress .edit-step'] = editStep.bind(this);
    }

    return this;
  }

  /**
   * Build a steps wizard instance.
   *
   * @returns {Object} the steps-wizard instance
   */
  build() {
    this.stepsWizardInstance = new StepsWizard(this);

    return this.stepsWizardInstance;
  }
}
